module.exports = __webpack_public_path__ + "bcfde2afce34512920e407010c36a980.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/download-arrow.svg
// module id = ./app/images/download-arrow.svg
// module chunks = 3